import React, { useState } from 'react';
import { ID, withCodes } from 'app/blocks/common/codes';
import InfoLabel from 'app/blocks/InfoLabel/InfoLabel';
import { MainTitle } from 'app/blocks/titles/titles';
import AdvanceSearchButtons from 'app/pages/search/advance-search-buttons/AdvanceSearchButtons';
import { navigate } from 'app/route/history';
import RadioButton from 'app/ui/form/RadioButton';

import './MissingArticleDetails.scss';

const NoOptionInfoBox = ({ l }) => (
    <InfoLabel className="MissingArticleDetails-InfoBox" seleniumId="missing-article-no-option-info">
        <div dangerouslySetInnerHTML={{ __html: l('SEARCH_CODES.SEARCH.ACCEPTED_FLOW.NO_OPTION_BOX') }} />
    </InfoLabel>
);

function MissingArticle({ l }) {
    const [isAccepted, setIsAccepted] = useState(undefined);

    return (
        <main className="col-lg-8 offset-lg-2" id="as-main-content-7f3d9e2a">
            <div className="MissingArticleDetails-Header">
                <MainTitle>{l('SEARCH_CODES.SEARCH.ACCEPTED_FLOW.title')}</MainTitle>
                <div
                    className="Description"
                    dangerouslySetInnerHTML={{ __html: l('SEARCH_CODES.SEARCH.ACCEPTED_FLOW.description') }}
                />
            </div>
            <div className="MissingArticleDetails-FormContent">
                <div dangerouslySetInnerHTML={{ __html: l('SEARCH_CODES.SEARCH.ACCEPTED_FLOW.text') }} />
                <div className="RadioButton">
                    <RadioButton
                        checked={isAccepted === true}
                        data-seleniumid="missing-article-accepted"
                        label={l('SEARCH_CODES.SEARCH.ACCEPTED_FLOW.YES_OPTION')}
                        name="missing-article-accepted-radio"
                        onChange={() => {
                            setIsAccepted(true);
                        }}
                        value
                    />
                </div>
                <div className="RadioButton">
                    <RadioButton
                        checked={isAccepted === false}
                        data-seleniumid="missing-article-not-accepted"
                        label={l('SEARCH_CODES.SEARCH.ACCEPTED_FLOW.NO_OPTION')}
                        name="missing-article-accepted-radio"
                        onChange={() => {
                            setIsAccepted(false);
                        }}
                        value={false}
                    />
                </div>
                {isAccepted === false && <NoOptionInfoBox l={l} />}
            </div>
            <AdvanceSearchButtons
                disableOnNext={isAccepted !== true}
                hidePrevious
                nextButtonText={l('SEARCH_CODES.SEARCH.ACCEPTED_FLOW.next_btn')}
                onNext={() =>
                    navigate(isAccepted ? '/index.html/advancedsearch' : '/index.html/get-help-on-article/rex')
                }
            />
        </main>
    );
}

export default withCodes(React.memo(MissingArticle), ID.SEARCH_CODES);
